import { Text } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import colors from "core/resources/theme/colors";
import React from "react";

// Número de itens por linha tem que ser divisor de 24 (2, 3, 6, 8, 12)
const rangeRows: string[][] = [
  ["A-B", "C-D", "E-F", "G-H", "I-J", "K-L"],
  ["M-N", "O-P", "Q-R", "S-T", "U-V", "W-Z"],
];

const maxItemsPerRow = rangeRows.reduce((acc, next) => {
  if (next.length > acc) {
    acc = next.length;
  }
  return acc;
}, 0);

const numRows = rangeRows.length;

interface FiltroRangeLetrasProps {
  selectedRange: string;
  onChangeRange: (range: string) => any;
}

function FiltroRangeLetras({
  selectedRange,
  onChangeRange,
}: FiltroRangeLetrasProps) {
  return (
    <Flex flexDir="column" gridGap={2}>
      {rangeRows.map((row, indexRow) => (
        <Box as={Row} gutter={8} key={indexRow}>
          {row.map((range, indexRange) => (
            <Box as={Col} sm={24 / maxItemsPerRow} key={indexRange}>
              <Flex
                borderWidth={1}
                borderColor={colors.primary}
                cursor="pointer"
                onClick={() => onChangeRange(range)}
                bg={selectedRange === range ? colors.primary : colors.white}
                roundedTopLeft={indexRow === 0 && indexRange === 0 ? 16 : 0}
                roundedBottomLeft={
                  indexRow === numRows - 1 && indexRange === 0 ? 16 : 0
                }
                roundedTopRight={
                  indexRow === 0 && indexRange === row.length - 1 ? 16 : 0
                }
                roundedBottomRight={
                  indexRow === numRows - 1 && indexRange === row.length - 1
                    ? 16
                    : 0
                }
                alignItems="center"
                justifyContent="center"
                minH="90px"
              >
                <Text
                  fontWeight={selectedRange === range ? "bold" : "regular"}
                  color={selectedRange === range ? colors.white : colors.black}
                  fontSize={22}
                >
                  {range}
                </Text>
              </Flex>
            </Box>
          ))}
        </Box>
      ))}
    </Flex>
  );
}

export default FiltroRangeLetras;
